import { motion } from "framer-motion";
import { useEffect, useState } from "react";

const Preloader = () => {
  const [pct, setPct] = useState(0);

  useEffect(() => {
    let raf;
    const start = performance.now();
    const dur = 2000;
    const tick = (t) => {
      const p = Math.min(1, (t - start) / dur);
      setPct(Math.round(p * 100));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <motion.div
      className="preloader-mask"
      initial={{ y: 0 }}
      exit={{ y: "-100%" }}
      transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
      data-testid="preloader"
    >
      <div className="absolute inset-0 flex flex-col justify-between p-6 md:p-10">
        <div className="flex justify-between items-start font-mono text-[11px] tracking-widest uppercase text-[color:var(--nn-muted)]">
          <span>NN Visuals — Portfolio Vol. 03</span>
          <span>Toronto · CA</span>
        </div>

        {/* Center rotating sun */}
        <div className="flex-1 flex items-center justify-center relative">
          <svg width="260" height="260" viewBox="0 0 200 200" className="text-[color:var(--nn-accent)] nn-spin-med">
            <g fill="currentColor">
              {Array.from({ length: 24 }).map((_, i) => (
                <rect key={i} x={99} y={4} width={2} height={40} rx={1} transform={`rotate(${(i / 24) * 360} 100 100)`} />
              ))}
              <circle cx="100" cy="100" r="38" />
            </g>
          </svg>
          <div className="absolute inset-0 grid place-items-center">
            <div className="font-display text-3xl md:text-4xl text-[color:var(--nn-accent-ink)]">
              {String(pct).padStart(3, "0")}
            </div>
          </div>
        </div>

        <div className="flex items-end justify-between">
          <div>
            <div className="font-mono text-[11px] tracking-widest uppercase text-[color:var(--nn-muted)] mb-2">
              Now Loading
            </div>
            <div className="h-display text-4xl md:text-6xl">
              Nirav <span className="font-serif-i text-[color:var(--nn-muted)]">Nayak</span>
            </div>
          </div>
          <div className="hidden md:block font-mono text-[10px] tracking-widest uppercase text-[color:var(--nn-muted)] text-right">
            <div>Senior Product Designer</div>
            <div className="text-[color:var(--nn-accent)] mt-1">◆ Available for hire</div>
          </div>
        </div>

        <motion.div
          className="absolute left-0 bottom-0 right-0 h-[3px] bg-[color:var(--nn-accent)]"
          initial={{ scaleX: 0 }}
          animate={{ scaleX: pct / 100 }}
          transition={{ duration: 0.1, ease: "linear" }}
          style={{ transformOrigin: "left center" }}
        />
      </div>
    </motion.div>
  );
};

export default Preloader;
